var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list-handler hover"},[_c('icon',{attrs:{"name":"solid-bars","size":0.6}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }